<template>

</template>

<script>
export default {
  name: 'AllRomates'
}
</script>

<style scoped>

</style>
